export default __webpack_public_path__ + "static/article-the-reality-of-work-and-travel-lisbon-2e7da38e36b214da3765055bfd72a42f.jpg";